import { RiskVariant } from "BrokerTsLib/src/enums"

export interface PropertyInsuranceTypeValues {
  propertyType: 'house' | 'flat' | null
  insuranceType: 'all' | RiskVariant.Realty | RiskVariant.Household | null
}

export interface IPropertyObject {
  id: number
  name: string
  // insuranceType: PropertyInsuranceTypeValues['insuranceType']
  insuranceType: number // RiskVariant
}

const housePropertyObjects: Array<IPropertyObject> = [
  {
    id: 1,
    name: 'Hlavní stavba',
    insuranceType: RiskVariant.Realty,
  },
  {
    id: 2,
    name: 'Vedlejší stavba',
    insuranceType: RiskVariant.Realty,
  },
  {
    id: 3,
    name: 'Stavební součásti',
    insuranceType: RiskVariant.Realty,
  },
  {
    id: 4,
    name: 'Sanitární zařízení',
    insuranceType: RiskVariant.Realty,
  },
  {
    id: 5,
    name: 'Technologická zařízení',
    insuranceType: RiskVariant.Realty,
  },
  {
    id: 6,
    name: 'Topení a kotle',
    insuranceType: RiskVariant.Realty,
  },
  {
    id: 7,
    name: 'Tepelná čerpadla',
    insuranceType: RiskVariant.Realty,
  },
  {
    id: 8,
    name: 'Klimatizace',
    insuranceType: RiskVariant.Realty,
  },
  {
    id: 9,
    name: 'Solární panely',
    insuranceType: RiskVariant.Realty,
  },
  {
    id: 10,
    name: 'Zabezpečovací systémy',
    insuranceType: RiskVariant.Realty,
  },
]

const houseHouseholdObjects: Array<IPropertyObject> = [
  {
    id: 1,
    name: 'Zařízení bytu',
    insuranceType: RiskVariant.Household,
  },
  {
    id: 2,
    name: 'Obuv a oblečení',
    insuranceType: RiskVariant.Household,
  },
  {
    id: 3,
    name: 'Zařizovací předměty',
    insuranceType: RiskVariant.Household,
  },
  {
    id: 4,
    name: 'Nábytek',
    insuranceType: RiskVariant.Household,
  },
  {
    id: 5,
    name: 'Elektronika',
    insuranceType: RiskVariant.Household,
  },
  {
    id: 6,
    name: 'Hudební nástroje',
    insuranceType: RiskVariant.Household,
  },
  {
    id: 7,
    name: 'Sportovní vybavení',
    insuranceType: RiskVariant.Household,
  },
  {
    id: 8,
    name: 'Cennosti',
    insuranceType: RiskVariant.Household,
  },
  {
    id: 9,
    name: 'Stavební součásti',
    insuranceType: RiskVariant.Household,
  },
  {
    id: 10,
    name: 'Věci v nebytových prostorech',
    insuranceType: RiskVariant.Household,
  },
]

const flatPropertyObjects: Array<IPropertyObject> = [
  {
    id: 1,
    name: 'Bytová jednotka',
    insuranceType: RiskVariant.Realty,
  },
  {
    id: 2,
    name: 'Vestavěné skříně',
    insuranceType: RiskVariant.Realty,
  },
  {
    id: 3,
    name: 'Stavební součásti',
    insuranceType: RiskVariant.Realty,
  },
  {
    id: 4,
    name: 'Sanitární zařízení',
    insuranceType: RiskVariant.Realty,
  },
  {
    id: 5,
    name: 'Topení a kotle',
    insuranceType: RiskVariant.Realty,
  },
  {
    id: 6,
    name: 'Tepelná čerpadla',
    insuranceType: RiskVariant.Realty,
  },
  {
    id: 7,
    name: 'Klimatizace',
    insuranceType: RiskVariant.Realty,
  },
  {
    id: 8,
    name: 'Solární panely',
    insuranceType: RiskVariant.Realty,
  },
  {
    id: 9,
    name: 'Zabezpečovací systémy',
    insuranceType: RiskVariant.Realty,
  },
  {
    id: 10,
    name: '',
    insuranceType: RiskVariant.Realty,
  },
]

const flatHouseholdObjects: Array<IPropertyObject> = [
  {
    id: 1,
    name: 'Zařízení bytu',
    insuranceType: RiskVariant.Household,
  },
  {
    id: 2,
    name: 'Obuv a oblečení',
    insuranceType: RiskVariant.Household,
  },
  {
    id: 3,
    name: 'Zařizovací předměty',
    insuranceType: RiskVariant.Household,
  },
  {
    id: 4,
    name: 'Nábytek',
    insuranceType: RiskVariant.Household,
  },
  {
    id: 5,
    name: 'Elektronika',
    insuranceType: RiskVariant.Household,
  },
  {
    id: 6,
    name: 'Hudební nástroje',
    insuranceType: RiskVariant.Household,
  },
  {
    id: 7,
    name: 'Sportovní vybavení',
    insuranceType: RiskVariant.Household,
  },
  {
    id: 8,
    name: 'Cennosti',
    insuranceType: RiskVariant.Household,
  },
  {
    id: 9,
    name: 'Stavební součásti',
    insuranceType: RiskVariant.Household,
  },
  {
    id: 10,
    name: 'Věci v nebytových prostorech',
    insuranceType: RiskVariant.Household,
  },
]

export const houseObjects = [...housePropertyObjects, ...houseHouseholdObjects]
export const flatObjects = [...flatPropertyObjects, ...flatHouseholdObjects]
